(function (angular) {
    'use strict';
    var app = angular.module('enervee.fastTrack');

    /*
     Creates a new controller for the rebate Fast Track form waiting for best rebate
     */
    app.controller('fastTrackWaitingModalCtrl', [
        '$uibModalInstance',
        'CmsContentService',
        function (
            $uibModalInstance,
            CmsContentService
        ) {
            var vm = this;
            CmsContentService.getMarketPlaceText('rebate_fast_track:form_loading_rebates').then(function (text) {
                vm.loadingRebatesText = text;
            });

            vm.dismissModal = function (reason) {
                $uibModalInstance.dismiss(reason || 'cancel');
            };
        }
    ]);

})(angular);
